/**
 * Import from all i18n libraries that we use
 */
import {
	useTranslation,
	Trans,
	I18nextProvider,
	initReactI18next,
} from "react-i18next"
import i18next, { TFunction } from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"

// Virtual modules (loading trough Vite)
import resources from "virtual:i18next-loader"

// Math
import { formatToDecimalPlaces } from "./math"

/**
 * getKeyAndValueFromNumber
 */
export const getKeyAndValueFromNumber = (
	number: number,
	formatter = formatToDecimalPlaces,
) => {
	let i18n = "numbers"
	let value: number

	if (number >= 1_000 && number < 1_000_000) {
		i18n = "numbers.thousand"
		value = formatter(number / 1_000)
	} else if (number >= 1_000_000 && number < 1_000_000_000) {
		i18n = "numbers.million"
		value = formatter(number / 1_000_000)
	} else if (number >= 1_000_000_000 && number < 1_000_000_000_000) {
		i18n = "numbers.billion"
		value = formatter(number / 1_000_000_000)
	} else if (number >= 1_000_000_000_000) {
		i18n = "numbers.trillion"
		value = formatter(number / 1_000_000_000_000)
	} else {
		value = formatter(number)
	}

	return { i18n, value }
}

/**
 * UseTranslation
 */
const useTrans = (namespace: string | string[] = "common") => {
	return useTranslation(namespace).t
}

// Export
export {
	i18next,
	useTrans,
	useTranslation,
	Trans,
	I18nextProvider,
	initReactI18next,
	LanguageDetector,
	resources,
}

// Types
export type { TFunction }
